import { BehaviorSubject } from 'rxjs';

export default function getCurrentLanguageCode(locale$: BehaviorSubject<string>) {
    return function() {
        return locale$.getValue();
    };
}
